import { render, staticRenderFns } from "./TableOccupationCard.vue?vue&type=template&id=d142d2c4&scoped=true"
import script from "./TableOccupationCard.vue?vue&type=script&lang=js"
export * from "./TableOccupationCard.vue?vue&type=script&lang=js"
import style0 from "./TableOccupationCard.vue?vue&type=style&index=0&id=d142d2c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d142d2c4",
  null
  
)

export default component.exports